import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import DeliveryScenarios from '@/types/table/deliveryScenarios';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface DeliveryScenariosData extends DeliveryScenarios {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class DeliveryScenariosController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<DeliveryScenariosData>>(API_CONTEXT + '/app/deliveryScenarios/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<DeliveryScenariosData>(API_CONTEXT + '/app/deliveryScenarios/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/deliveryScenarios/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/deliveryScenarios/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/deliveryScenarios/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/deliveryScenarios/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/deliveryScenarios/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/deliveryScenarios/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/deliveryScenarios/deleteBatch', params, httpOptions);
  }
}
